<template>
  <a-card class="loading">
    <div style="display: flex;align-items: center;justify-content: space-between;margin-bottom: 20px">
        <span style="font-weight: bold;font-size: 16px">
          网关信息:
        </span>
      <a-button type="primary" @click="update">刷新</a-button>
    </div>
    <a-spin :spinning="single.currentCode.info.length === 0">
      <div v-if="single.currentCode.info.length !== 0">
        <a-descriptions :column="2" bordered>
          <a-descriptions-item label="软件版本">{{ single.currentCode.info[0] }}</a-descriptions-item>
          <a-descriptions-item label="BT版本">{{ single.currentCode.info[8] }}</a-descriptions-item>
          <a-descriptions-item label="开机时间">{{ single.currentCode.info[1] }}</a-descriptions-item>
          <a-descriptions-item label="二维码">{{ single.currentCode.info[6] }}</a-descriptions-item>
          <a-descriptions-item label="eth-MAC">{{ single.currentCode.info[2].split(' ')[0] }}</a-descriptions-item>
          <a-descriptions-item label="wifi-MAC">{{ single.currentCode.info[14].split(' ')[0] }}</a-descriptions-item>
          <a-descriptions-item label="eth-ip">{{ single.currentCode.info[2].split(' addr:')[1] || '暂无' }}
          </a-descriptions-item>
          <a-descriptions-item label="wifi-ip">{{ single.currentCode.info[14].split(' addr:')[1] || '暂无' }}
          </a-descriptions-item>
          <a-descriptions-item label="BT-MAC">{{ single.currentCode.info[13] }}</a-descriptions-item>
          <a-descriptions-item label="4G-ICCID">
            未获取
          </a-descriptions-item>
          <a-descriptions-item label="设置地锁">
            <a-space>
              <a-select
                  ref="select"
                  v-model:value="lockWorkMode"
                  style="width: 120px"
              >
<!--                <a-select-option :value="0">普通模式</a-select-option>-->
                <a-select-option :value="1">超声波联动</a-select-option>
<!--                <a-select-option :value="2">固定感应模式</a-select-option>-->
              </a-select>
              <a-input-number
                  v-model:value="threshold"
                  :style="{width:'100px'}"
                  :min="0"
                  placeholder="输入超声波阈值"
              />cm
              <a-button @click="issuedThreshold">下发</a-button>
            </a-space>
          </a-descriptions-item>
        </a-descriptions>
      </div>
      <div v-else class="loading"></div>
    </a-spin>
  </a-card>
</template>
<script setup>
import singleDev from "@/stores/singleDev";
import {ref} from "vue";
import mqttTool from "@/utils/mqtt/index"
import load from "@/common/load";

let single = singleDev();

// 地锁工作模式
let lockWorkMode = ref(1);
// 刷新
let update = () => {
  single.changeCurrentCode(single.currentCode.qrCode)
}
let threshold = ref(50);
let issuedThreshold = () => {
  load.confirm('是否下发参数？', async () => {
    // 传递消息的方法
    mqttTool.deliverTheMessage = (topic, message) => {
      console.log(topic)
      console.log(message)
    };
    if (mqttTool.subscribeSuccess) {
      mqttTool.doUnSubscribe();
    }
    mqttTool.subscription.topic = '/Beefind/prep/v1/up/lockgateway/set_lockparams/'
    // 订阅主题
    mqttTool.doSubscribe();
    mqttTool.publish.topic = '/Beefind/prep/v1/down/lockgateway/set_lockparams/'
    // 发布信息
    mqttTool.publish.payload = JSON.stringify({
      'devices': [],
      'data': {
        'ultraThreshold': threshold.value,
        'workMode': lockWorkMode.value,
      }
    });
    mqttTool.doPublish();
    load.loading("加载最新地锁数据...");
    single.getlocks(true);
  })
}
</script>


<style scoped lang="scss">
.loading {
  display: flex;
  min-width: 32vw;
  min-height: 30vh;
  align-items: center;
  justify-content: center;
}
</style>
